import { uuidModule } from "@/modules/uuid";
import { NoteModelData, NoteUpsertedSyncUpdateValue } from "@/store/note/types";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { IUpdateNoteLocallyCreatedAtOperation } from "@/store/sync/operations/types";
import { OptimisticSyncUpdate, SyncModelData } from "@/store/sync/types";

export class UpdateNoteLocallyCreatedAtOperation extends BaseSyncOperation<IUpdateNoteLocallyCreatedAtOperation> {
  get operationKind(): "UPDATE_NOTE_LOCALLY_CREATED_AT" {
    return "UPDATE_NOTE_LOCALLY_CREATED_AT";
  }

  async generateOptimisticUpdates(): Promise<OptimisticSyncUpdate<SyncModelData>[]> {
    const note = await this.store.notes.getAsync(this.payload.id);
    if (!note) return [];

    const value: NoteUpsertedSyncUpdateValue = {
      model_id: this.payload.id,
      model_kind: "NOTE",
      model_version: note.modelVersion,
      model_data: {
        ...note.modelData,
        locally_created_at: this.payload.new_locally_created_at,
        locally_modified_at: this.committedAt,
      },
      model_scopes: note.modelScopes,
    };

    const syncUpdate: OptimisticSyncUpdate<NoteModelData> = {
      optimistic_update_id: uuidModule.generate(),
      locally_committed_at: this.committedAt,
      kind: "UPSERTED",
      value,
    };
    return [syncUpdate];
  }

  async triggerRecompute() {
    await this.store.notes.recompute(this.payload.id);
  }
}
